import React from 'react';

import { FormGroup, Input, Label } from 'reactstrap';

import Component from "./Component";

export default ({ data }) => {

  const [showDecommissioned, setShowDecommissioned] = React.useState(false);

  return (
    <React.Fragment>
      <FormGroup
        check
        className='mb-2 text-right'
      >
        <Label check>
          <Input
            type="checkbox"
            checked={showDecommissioned}
            onChange={(e) => setShowDecommissioned(e.target.checked)}
          />{' '}
          Show decommissioned assets
        </Label>
      </FormGroup>

      <Component
        className="top-level-container"
        component={data}
        showDecommissioned={showDecommissioned}
      />
    </React.Fragment>
  );
};
